import React from "react";
import GuideHeader from "../Guide/GuideHeader";
import "./GuideEffectiveEmail.css";

const GuideEffectiveEmail = () => {
  const tips = [
    {
      number: 1,
      title: "Don’t forget the preview text",
      text: "The email preview gives your subscribers a glimpse into your email and helps them decide if they should read it. It’s an important but often-overlooked part of increasing your open rate. Make sure the preview text is inviting – write something short, snappy and intriguing.",
    },
    {
      number: 2,
      title: "Less is more",
      text: "Keep your copy short so readers don’t have to keep scrolling down to get to the point. Keep paragraphs short and be as succinct as you can.",
    },
    {
      number: 3,
      title: "Try to avoid sounding salesy",
      text: "Sure, you have a product to sell – but you don’t want to come across as aggressive or manipulative. Use a conversational tone and emphasise what value you’re providing to your customer.",
    },
    {
      number: 4,
      title: "Keep it relevant",
      text: "Make sure you’re targeting the right subscribers with the right product or offer that’s specifically relevant to them. There’s nothing worse than getting emails that are completely irrelevant to you.",
    },
    {
      number: 5,
      title: "Keep it consistent",
      text: "Stick to a clear tone of voice that reflects your brand. Readers will start recognising your emails by the way they sound, so consistency builds familiarity and trust.",
    },
    {
      number: 6,
      title: "Check, check and check again",
      text: "Be sure to proofread and make sure there aren’t any mistakes. Knowing the difference between 'there', 'their' and 'they’re' will help you build trust.",
    },
    {
      number: 7,
      title: "Include a CTA (Call To Action)",
      text: "A CTA is a button or link that tells your reader exactly what they should do next once they’ve read your email. Avoid generic phrases like 'read more' or 'click here'; be creative and inviting – how about 'Tell me all about it' or 'read the full story' instead?",
    },
    {
      number: 8,
      title: "Personalise",
      text: "Your reader should feel like the emails you send are specifically tailored to them. Use merge tags to include their name at the beginning of your email or in the subject line.",
    },
  ];

  return (
    <div className="guide-page">
      {/* ✅ Reusable Mailsnappy Header */}
      <GuideHeader headingLevel="div" />

      {/* 📧 Page Content */}
      <section className="effective-content">
        <h1>How to write an effective email</h1>
        <p className="intro-text">
          Whatever you’re trying to achieve with your emails, you’ll want to make sure they’re written
          well. Good copy is essential for engaging your audience, earning their trust and boosting
          clicks or sales. Here are eight tips to help you get your message across.
        </p>

        <div className="effective-tips">
          {tips.map((tip) => (
            <div key={tip.number} className="tip-box">
              <div className="tip-number">{tip.number}</div>
              <div className="tip-content">
                <h3>{tip.title}</h3>
                <p>{tip.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="next-step">
          <p>
            Now you’re all set with the basics, let’s move forward onto some more advanced email
            marketing.
          </p>
          <p className="next-link">
            Read how to <a href="/guide">personalise your campaigns →</a>
          </p>
        </div>
      </section>

      {/* 🌊 CTA Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
      </section>
    </div>
  );
};

export default GuideEffectiveEmail;
